<template>
  <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
    <zj-layout-header>
      <div class="listtitle">项目资料</div>
      <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
        <el-form-item label="上传日期">
          <el-date-picker
            v-model="CreateTime"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="AssocSubModule" placeholder="请输入项目名称"></el-input>
        </el-form-item>
        <el-form-item label="资料分类">
          <el-select v-model="Extends2" placeholder="请选择">
            <el-option key label="全部" value></el-option>
            <el-option
              v-for="item in FileCategoryList"
              :key="item.ParameterKey"
              :label="item.ParameterName"
              :value="item.ParameterName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="格式">
          <el-input v-model="Extension" placeholder="请输入格式"></el-input>
        </el-form-item>
        <el-form-item label="资料名称">
          <el-input v-model="FileName" placeholder="请输入资料名称"></el-input>
        </el-form-item>
        <el-form-item label class="right">
          <el-button @click="onSearch">查 询</el-button>
          <el-button @click="onCancel">清 理</el-button>
        </el-form-item>
      </el-form>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-button-bar" v-show="disabledUpload">
        <el-upload
          :http-request="httpRequest"
          :show-file-list="false"
          :before-upload="beforeupload"
          :on-success="uploadsuccess"
          :on-progress="uploadProgress"
          :on-error="uploadError"
          :data="uploadData"
          :file-list="fileList">
          <el-button size="mini" @click="onAdd">添 加</el-button>
          <!-- <el-button size="mini" type="primary">上 传</el-button> -->
        </el-upload>
      </div>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="FileName" label="资料名称"></el-table-column>
            <el-table-column prop="AssocSubModule" label="所属项目"></el-table-column>
            <el-table-column prop="Extends2" label="分类"></el-table-column>
            <el-table-column prop="Extension" label="格式"></el-table-column>
            <el-table-column prop="Creater" label="上传人"></el-table-column>
            <el-table-column prop="FileSize" label="文件大小"></el-table-column>
            <!-- <el-table-column prop="CreateTime" label="上传日期" :formatter="formatDate"></el-table-column> -->
            <!-- <el-table-column prop="AssocModule" label="模块名称"></el-table-column> -->
            <el-table-column label="操作" width="120" align="center">
              <template slot-scope="scope">
                <el-button v-if="scope.row.Extension !== 'jpg' && scope.row.Extension !== 'png' && scope.row.Extension !== 'gif'" @click="DownLoad(scope.$index, scope.row)" type="text" size="small">下载</el-button>
                <el-button v-else @click="DownLoad(scope.$index, scope.row)" type="text" size="small">预览</el-button>
                <el-button @click="DeleteFile(scope.$index, scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import MyApis from "../../../apis";
import ZJApp from "../../../../../app";
export default {
  name: "FileList",
  controller: "UI",
  action: "FileList",
  props: {
    assocID: String,
    module: String,
    submodule: String,
    disabledUpload: { type: Boolean, default: true },
  },
  data() {
    return {
      CreateTime: "",
      AssocSubModule: "",
      Extends2: "",
      Extension: "",
      FileName: "",

      currentPage: 1,
      pageSize: 20,
      total: 0,
      
      loading: false,
      loadingText: "加载中...",
      tableData: [],
      FileCategoryList: [
        {
          ParameterKey: '1',
          ParameterName: '合同'
        },
        {
          ParameterKey: '2',
          ParameterName: '设计资料'
        },
        {
          ParameterKey: '3',
          ParameterName: '过程文档'
        },
        {
          ParameterKey: '4',
          ParameterName: '验收资料'
        }
      ],
      FileTypeList: []
    };
  },
  created: function () {
    // this.GetMaterialCategory();
    this.GetMaterialFileType();
    this.search();
  },
  mounted: function () {},
  methods: {
    GetMaterialCategory() {
      new MyApis.MaterialConfigurationApi()
        .GetAllMaterialCategory()
        .then((r) => {
          r = r.data.Data;
          this.FileCategoryList = r.PageContents;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetMaterialFileType() {
      new MyApis.MaterialConfigurationApi()
        .GetAllMaterialFileType()
        .then((r) => {
          r = r.data.Data;
          this.FileTypeList = r.PageContents;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CreateTime = "";
      this.AssocSubModule = "";
      this.Extends2 = "";
      this.Extension = "";
      this.FileName = "";
    },
    onAdd() {
      this.$router.push({
        path: "/plugin/MaterialManage/UI/FileInfo",
        query: {
          type: "add",
          assocID: this.assocID,
          module: this.module
        },
      });
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    search() {
      let searchinfo = {
        CreateTime: this.CreateTime,
        AssocSubModule: this.AssocSubModule?"*"+this.AssocSubModule+"*":"",
        Extends2: this.Extends2,
        Extension: this.Extension,
        FileName: this.FileName?"*"+this.FileName+"*":"",

        AssocModule: this.module,
        AssocID: this.assocID,
        
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
		OrderBy:"CreateTime desc",
      };
      this.loadingText = "加载中...";
      this.loading = true;
      new MyApis.FileApi()
        .GetFileList(searchinfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.FileList;
          this.total = r.RecordCount;
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    DownLoad(index, row) {
      var downloadpath = row.DownloadPath;
      if (row.Extension !== 'jpg' && row.Extension !== 'png' && row.Extension !== 'gif') {
        window.location.href = downloadpath;
      } else {
        window.open(downloadpath);
      }     
    },
    DeleteFile(index, row) {
      var ids = [];
      ids.push(row.FileID);
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.loadingText = "删除中...";
        new MyApis.FileApi()
          .DeleteFile(ids)
          .then((r) => {
            r = r.data.Data;
            if (r) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
            this.loading = false;
            this.search();
          })
          .catch((e) => {
            this.loading = false;
            console.log(e);
            this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          });
      });
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm:ss");
    },
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    }
  }
};
</script>
<style scoped>
.zj-search-form {
  overflow: hidden;
}
</style>
